export default "__VITE_ASSET__yYy6crJn__"